import { useWireValue } from '@forminator/react-wire'
import * as store from '@store'
import * as actions from '@actions'
import { useEffect, useState } from 'react'
import CustomModal from '@/components/shared/CustomModal/CustomModal'
import { toast } from 'react-toastify'

/* export type AssignCollectionToUserProps = {
    showAdd: boolean
    showHideAdd: (showAdd: boolean) => void
    collection?: Collection
    selectedModelIds: string[]
} */

export const AssignCollectionToUser = ({
    showAdd,
    showHideAdd,
    collection,
    
    // selectedModelIds = [], // @todo unused?
}) => {
    const [selectedUsers, setSelectedUsers] = useState([])
    const users = useWireValue(store.users)
    
    useEffect(() => {
        actions.fetchUsers()
    }, [])
    
    useEffect(() => {
        if (!collection?.assignedTo) return
        setSelectedUsers(collection?.assignedTo?.map(({ id }) => id) ?? [])
    }, [collection])
    
    const compareUsers = (users1, users2, key) => {
        
        const user1 = users1[key].toUpperCase()
        const user2 = users2[key].toUpperCase()
        
        if (user1 < user2) return -1
        if (user1 > user2) return 1
        
        return 0
        
    }
    
    users?.sort((user, user2) => {
        return compareUsers(user, user2, 'firstName')
    })
    
    return (
        <CustomModal open={showAdd} modalHandler={() => showHideAdd(!showAdd)} center>
            <div className="card">
                <div className="card-header">Assign Collection To User</div>
                <div className="card-body">
                    <h3>Collection: {collection?.name}</h3>
                    
                    <ul className="list-group list-group-flush">
                        {(users || []).map(user => (
                            <li className="list-group-item " key={user.id}>
                                <div className="row">
                                    <div className="col-1">
                                        <input
                                            type="checkbox"
                                            className="checkbox-user"
                                            value={user.id}
                                            name="user"
                                            checked={selectedUsers.indexOf(user.id) >= 0}
                                            onChange={e => {
                                                if (e.target.checked) {
                                                    setSelectedUsers([...selectedUsers, user.id])
                                                } else {
                                                    let filtered = selectedUsers.filter(
                                                        userList => userList !== user.id,
                                                    )
                                                    
                                                    setSelectedUsers(filtered)
                                                }
                                            }} />
                                    </div>
                                    <div className="col-11">{`${user.firstName} ${user.lastName}`}</div>
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
            <div className="modal-footer flex justify-between">
                <button
                    type="button"
                    className="btn btn-primary btn-outline"
                    onClick={() => {
                        showHideAdd(!showAdd)
                    }}>
                    Cancel
                </button>
                <button
                    type="submit"
                    className="mr-3 btn btn-primary"
                    onClick={async () => {
                        toast.warn('Not implemented yet')
                        
                        // await actions.assignToUser([collection?.id], selectedUsers)
                        await showHideAdd(!showAdd)
                        
                        // @todo fn doesn't exist await actions.getCollection(collection?.id || '')
                    }}
                    disabled={!selectedUsers.length}>
                    Assign
                </button>
            </div>
        </CustomModal>
    )
}
